import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { AutoCompleteSelectOption } from '../../components/selectComponents/autoCompleteSelectOption';
import { SelectOption } from '../../components/selectComponents/SelectOption';
import TextField from '@mui/material/TextField';
import { useGetSkuPerMarket } from '../../hooks/useGetSkuPerMarket';

export const RSAllocationRuleForm = ({ formik, config, onCancel }) => {

  const skus = useGetSkuPerMarket(config?.configurationParameters?.country);

  const loading = !skus.skusForMarket.length;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );
  }


  const skuOptions = ((skus.skusForMarket || []) as Array<string | { SKU: string }>)
    .map(sku => typeof sku === 'string' ? sku : sku?.SKU)
    .filter((sku): sku is string => typeof sku === 'string' && !!sku);

  return (
    <Box>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          <AutoCompleteSelectOption
            formik={formik}
            formikValue="SKU"
            optionsList={skuOptions}
            title="SKU"
            titleVariant="body2"
            touchedField="SKU"
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ minWidth: 350 }}>
            <SelectOption
              formik={formik}
              formikValue="currencyId"
              optionsList={config.configurationParameters?.currencies}
              title="Select Currency"
              titleVariant="body2"
              touchedField="currencyId"
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            Amount
          </Typography>
          <TextField
            label="Amount"
            variant="outlined"
            fullWidth
            value={formik.values.amount}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type="number"
            margin="none"
            name="amount"
            InputProps={{
              style: { backgroundColor: '#fff' }
            }}
          />
        </Grid>
      </Grid>
      <Box mt={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              onClick={onCancel}
              color="secondary"
              variant="outlined"
              fullWidth
              sx={{
                borderColor: '#000',
                color: '#000',
                fontWeight: 600,
                backgroundColor: '#fff',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                  borderColor: '#000',
                },
              }}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              fullWidth
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
